import React from "react";
import { connect } from 'react-redux'

import MaterialTable from 'material-table';
import { CardBody, Card, Row, Col,  FormGroup, Label, Button  } from 'reactstrap';
import Select from "react-select";

import { Spinner } from 'components/Icons/Spinner';
 

var api = require ('../api');

var viewActions = require ('store/view.actions');


class ReportList extends React.Component {


  componentDidMount() {
    // this.props.getTutorCourses(this.props.token,  this.props.currentCalendarID) ;
    // this.props.getTeacherCourses (this.props.token,  this.props.user.persona_id , this.props.currentCalendarID) 
   
    this.props.setMainTitle("Generación de reportes", [] )
  }

  constructor(props) {
    super(props);
    this.state = {
        selectedReport: false,
        loadingReport: false
    }

 }

loadReport () {
    this.setState( { loadingReport: true });
    api.getEndpoint(this.props.token, this.props.currentCalendarID, this.state.selectedReport.endpoint ) 
        .then( json => {
            let dev = json.map( (data) => { 
                let dev = {};
                this.state.selectedReport.reportColumns.map( (f) => {
                    dev[f.field] = data[f.field];
                })
                return dev;
            });
            this.setState({ reportData: dev, loadingReport: false });
           
        } )
}
 
  render() {
    const reports = [
        { 
            value: "ENROLED", 
            label: "Inscriptos por curso",
            reportTitle: "Inscriptos por curso",
            endpoint: "courses",
            reportColumns: [
                { title: "Curso", field: "name" },
                { title: "Turno", field: "shift_name" },
                { title: "Nivel", field: "top_name"},
                { title: "Inscriptos", field: "total_enroled", type: "numeric" } 
              ]
        }
          ]

    return (
      <>
        <div className="content">
        <Card>
                    <CardBody>
                       <Row>
                          <Col sm="3"> 
                            <FormGroup>
                              <Label>Reporte</Label>
                              <Select
                                      name="current"
                                      onChange={(sel) => this.setState({selectedReport: sel})}
                                      options={reports}
                                      placeholder="Seleccione reporte"
                                    />
                            </FormGroup>
                          </Col>
                         
                          <Col sm="3">
                              <Button 
                                  style={{marginTop: "26px"}}
                                  color={this.state.loadingReport?"info":"success"}
                                  disabled={!this.state.selectedReport} 
                                  onClick={() => this.loadReport()}
                                  >
                                {!this.state.loadingReport ?
                                   <>Cargar reporte</>
                                   :
                                   <>Cargando <Spinner /> </>
                                }
                              </Button>

                          </Col>
                        </Row>
                    </CardBody>
                  </Card>
                
                    <MaterialTable
                        title={ this.state.selectedReport.reportTitle?this.state.selectedReport.reportTitle:'Reporte sin cargar' }
                        data={ this.state.reportData }  
                        columns={  this.state.selectedReport.reportColumns}
                        options={{
                            exportButton: {
                                csv: false,
                                pdf: true
                            } ,
                            search: false,
                            paging: false
                        }}
                        localization={{
                            toolbar: {
                              exportCSVName: "Exportar CSV",
                              exportPDFName: "Exportar PDF"
                            }
                          }}
                    />
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        tutorCourses: state.tutors.tutorCourses,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
         setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        
      
 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(ReportList);

